export default "__VITE_ASSET__f5NOXcql__"